import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Densities,
  TopBarBase,
} from 'shared/components/connected/top-bar-base';

import { PeriodSelection } from '../period-selection';
import { SettingsMenu } from '../settings-menu';
import * as Styled from './page-top-bar.style';

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <TopBarBase
        hideBorder
        density={Densities.Compact}
        mobileNavigationSlot={
          <Styled.MobilePeriodSelectionContainer>
            <PeriodSelection />
          </Styled.MobilePeriodSelectionContainer>
        }
      >
        <Styled.Content>
          <Styled.Title>
            <Typography variant="h5" component="h1">
              {t('pages.insights.title')}
            </Typography>
          </Styled.Title>

          <Styled.PeriodSelectionContainer>
            <PeriodSelection />
          </Styled.PeriodSelectionContainer>

          <SettingsMenu />
        </Styled.Content>
      </TopBarBase>
    </Styled.Container>
  );
};
